// Global request manager to prevent infinite API loops
class RequestManager {
  private static instance: RequestManager;
  private requestCounts: Map<string, number> = new Map();
  private lastRequestTime: Map<string, number> = new Map();
  private readonly MAX_REQUESTS_PER_MINUTE = 10;
  private readonly REQUEST_COOLDOWN = 5000; // 5 seconds
  private readonly PROPOSAL_VOTE_CHECK_COOLDOWN = 10000; // 10 seconds for vote checks
  private globalErrorCount = 0;
  private readonly MAX_GLOBAL_ERRORS = 50;
  private circuitBreakerOpen = false;

  static getInstance(): RequestManager {
    if (!RequestManager.instance) {
      RequestManager.instance = new RequestManager();
    }
    return RequestManager.instance;
  }

  canMakeRequest(endpoint: string): boolean {
    // Check global circuit breaker
    if (this.circuitBreakerOpen) {
      console.warn(`Global circuit breaker is OPEN. Blocking all requests.`);
      return false;
    }

    const now = Date.now();
    const lastRequest = this.lastRequestTime.get(endpoint) || 0;
    const requestCount = this.requestCounts.get(endpoint) || 0;

    // Reset counter every minute
    // if (now - lastRequest > 60000) {
    //   this.requestCounts.set(endpoint, 0);
    // }

    // Check if we've exceeded the rate limit
    // if (requestCount >= this.MAX_REQUESTS_PER_MINUTE) {
    //   console.warn(`Rate limit exceeded for ${endpoint}. Blocking request.`);
    //   return false;
    // }

    // Check cooldown period - use longer cooldown for vote checks
    // const cooldownPeriod = endpoint === 'ProposalVoteCheck' ? this.PROPOSAL_VOTE_CHECK_COOLDOWN : this.REQUEST_COOLDOWN;
    // if (now - lastRequest < cooldownPeriod) {
    //   console.warn(`Cooldown period active for ${endpoint} (${cooldownPeriod}ms). Blocking request.`);
    //   return false;
    // }

    return true;
  }

  recordRequest(endpoint: string): void {
    const now = Date.now();
    const requestCount = this.requestCounts.get(endpoint) || 0;
    this.requestCounts.set(endpoint, requestCount + 1);
    this.lastRequestTime.set(endpoint, now);
  }

  recordError(): void {
    this.globalErrorCount++;
    console.warn(`Global error count: ${this.globalErrorCount}/${this.MAX_GLOBAL_ERRORS}`);
    
    if (this.globalErrorCount >= this.MAX_GLOBAL_ERRORS) {
      this.circuitBreakerOpen = true;
      console.error(`🚨 CIRCUIT BREAKER OPENED! Too many errors (${this.globalErrorCount}). All API calls blocked.`);
      
      // Force stop all React components from making more requests
      if (typeof window !== 'undefined') {
        (window as any).CIRCUIT_BREAKER_OPEN = true;
        console.error(`🚨 EMERGENCY STOP: All React components should stop making API calls!`);
      }
    }
  }

  reset(): void {
    this.requestCounts.clear();
    this.lastRequestTime.clear();
    this.globalErrorCount = 0;
    this.circuitBreakerOpen = false;
    console.log("Request manager reset - all counters cleared and circuit breaker closed");
  }
}

export default RequestManager;
